(() => {
  'use strict';
  const config = window.tdtLanguage;
  if (!config || !Array.isArray(config.languages)) return;
  const choiceKey = 'tdt-language-choice-v1';
  const attemptKey = 'tdt-language-attempt-v2';
  const read = (storage, key) => { try { return window[storage].getItem(key); } catch (_) { return null; } };
  const write = (storage, key, value) => { try { window[storage].setItem(key, value); } catch (_) {} };
  const remove = (storage, key) => { try { window[storage].removeItem(key); } catch (_) {} };
  const cookie = key => {
    try { return decodeURIComponent((document.cookie.split('; ').find(part => part.startsWith(key + '=')) || '').slice(key.length + 1)); } catch (_) { return ''; }
  };
  function clearAttempt() {
    remove('sessionStorage', attemptKey);
    try { document.cookie = attemptKey + '=; Path=/; Max-Age=0; SameSite=Lax; Secure'; } catch (_) {}
  }
  function rememberAttempt(value) {
    write('sessionStorage', attemptKey, value);
    if (read('sessionStorage', attemptKey) === value) return true;
    try { document.cookie = attemptKey + '=' + encodeURIComponent(value) + '; Path=/; Max-Age=15; SameSite=Lax; Secure'; } catch (_) {}
    return cookie(attemptKey) === value;
  }
  const languageForm = document.getElementById('tdt-language-form');
  function withoutPrefix(path) {
    const parts = path.split('/');
    if (config.languages.includes((parts[1] || '').split('-')[0]) && /^[a-z]{2}(?:-[a-z]{2})?$/.test(parts[1])) parts.splice(1, 1);
    return parts.join('/') || '/';
  }
  function returnPath(locale) {
    const prefix = location.pathname.split('/')[1] || '';
    const suffix = config.languages.includes(prefix.split('-')[0]) && /^[a-z]{2}-[a-z]{2}$/.test(prefix) ? '-' + prefix.split('-')[1] : '';
    const base = suffix ? '/' + locale + suffix : locale === config.primary ? '' : '/' + locale;
    return base + withoutPrefix(location.pathname) + location.search + location.hash;
  }
  function prepare(form, locale) {
    let target = form.querySelector('[name="return_to"]');
    if (!target) { target = document.createElement('input'); target.type = 'hidden'; target.name = 'return_to'; form.appendChild(target); }
    target.value = returnPath(locale);
  }
  // A deliberate language choice always wins over device-language detection.
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const field = form.querySelector('[name="language_code"]');
    if (event.isTrusted && field && config.languages.includes(field.value)) {
      write('localStorage', choiceKey, field.value);
      write('sessionStorage', choiceKey, field.value);
      clearAttempt();
      prepare(form, field.value);
    }
  }, true);
  const preference = [read('localStorage', choiceKey), read('sessionStorage', choiceKey)].find(value => config.languages.includes(value));
  const browserLanguages = Array.from(navigator.languages || []);
  if (!browserLanguages.length && navigator.language) browserLanguages.push(navigator.language);
  const deviceLanguage = browserLanguages.map(value => String(value).toLowerCase().split(/[-_]/)[0]).find(value => config.languages.includes(value));
  const explicitDanish = /^\/da(?:-dk)?(?:\/|$)/i.test(location.pathname);
  const desiredLanguage = explicitDanish ? 'da' : preference || deviceLanguage || config.primary;
  if (explicitDanish) { write('sessionStorage', choiceKey, 'da'); write('localStorage', choiceKey, 'da'); }
  let attempt;
  try { attempt = JSON.parse(read('sessionStorage', attemptKey) || cookie(attemptKey) || 'null'); } catch (_) {}
  const age = attempt ? Date.now() - attempt.at : Infinity;
  const recentlyAttempted = attempt && attempt.to === desiredLanguage && age >= 0 && age < 15000;
  if (config.locale === desiredLanguage) clearAttempt();
  const languageField = languageForm && languageForm.querySelector('[name="language_code"]');
  if (languageField && config.languages.includes(desiredLanguage) && config.locale !== desiredLanguage && !recentlyAttempted && !(window.Shopify && window.Shopify.designMode) && rememberAttempt(JSON.stringify({to: desiredLanguage, at: Date.now()}))) {
    languageField.value = desiredLanguage;
    prepare(languageForm, desiredLanguage);
    HTMLFormElement.prototype.submit.call(languageForm);
    return;
  }
  // Repair stale generated language prefixes, but never rewrite language selectors,
  // external URLs, account links, checkout tokens or explicit hreflang links.
  const internalPath = /^\/(?:products|collections|pages|blogs|cart|search)(?:\/|\.|$)/;
  function fixLink(link) {
    if (link.hasAttribute('hreflang') || link.closest('.tdt-language-selector,[data-disclosure-locale],.localization-form')) return;
    const raw = link.getAttribute('href');
    if (!raw || raw.startsWith('#')) return;
    let url;
    try { url = new URL(raw, location.href); } catch (_) { return; }
    if (url.origin !== location.origin) return;
    const neutral = withoutPrefix(url.pathname);
    if (!internalPath.test(neutral) && neutral !== '/') return;
    const path = config.root.replace(/\/$/, '') + neutral;
    if (path !== url.pathname) link.setAttribute('href', path + url.search + url.hash);
  }
  function linksIn(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches('a[href]')) fixLink(root);
    root.querySelectorAll('a[href]').forEach(fixLink);
  }
  linksIn(document);
  const german = config.locale.split('-')[0] === 'de';
  const danish = config.locale.split('-')[0] === 'da';
  const copy = new Map(danish ? [
    ['Sædevalg','Vælg siddeplads'],['Seatselection','Vælg siddeplads'],['Seat selection','Vælg siddeplads'],['Sitzplatz wählen','Vælg siddeplads'],
    ['1. Zoom in and select a seat','Zoom ind og vælg en farvet plads'],['1. Zoom ind og vælg et sæde','Zoom ind og vælg en farvet plads'],
    ['Zoomen & farbigen Platz wählen','Zoom ind og vælg en farvet plads'],['2. Klik på knappen',''],['2. Click the button',''],['2. Button klicken',''],
    ['Your reservation','Din reservation'],['Please select seats','Vælg venligst siddepladser'],['Add to cart','Tilføj til kurv'],['Sold out','Udsolgt']
  ] : [
    ['Seatselection', 'Sitzplatz wählen'], ['Seat selection', 'Sitzplatz wählen'],
    ['Your reservation', 'Deine Reservierung'],
    ["You don't have a reservation yet", 'Du hast noch keine Plätze ausgewählt'],
    ['1. Zoom in and select a seat', 'Zoomen & farbigen Platz wählen'],
    ['2. Click the button', ''], ['2. Button klicken', ''],
    ['Discounts in the next step', ''],
    ['Please select seats', 'Bitte Sitzplätze wählen'],
    ['Add to cart', 'In den Warenkorb'], ['Sold out', 'Ausverkauft']
  ]);
  function translate(root) {
    if (!german && !danish) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement && node.parentElement.closest('script,style')) continue;
      const text = node.nodeValue.trim();
      let replacement = copy.get(text);
      if (replacement === undefined && /^All categories\s+from\b/.test(text)) replacement = text.replace(/^All categories\s+from\s*/, danish ? 'Alle kategorier fra ' : 'Alle Kategorien ab ');
      if (replacement === undefined && text === 'All categories') replacement = danish ? 'Alle kategorier' : 'Alle Kategorien';
      if (replacement !== undefined && replacement !== text) node.nodeValue = replacement;
    }
    root.querySelectorAll('.tips p').forEach(p => { if (!p.textContent.trim()) p.remove(); });
    root.querySelectorAll('[data-smmodal-close]').forEach(b => b.setAttribute('aria-label', danish ? 'Luk salplanen' : 'Saalplan schließen'));
  }
  const watched = new WeakSet();
  function ticketUI(root) {
    if ((!german && !danish) || (root.nodeType !== 1 && root.nodeType !== 9)) return;
    const targets = [];
    if (root.matches && root.matches('[data-smmodal-open],.seating-app-smmodal')) targets.push(root);
    targets.push(...root.querySelectorAll('[data-smmodal-open],.seating-app-smmodal'));
    targets.forEach(target => {
      translate(target);
      if (watched.has(target)) return;
      watched.add(target);
      let queued = false;
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        queueMicrotask(() => { queued = false; translate(target); });
      }).observe(target, {childList:true, subtree:true, characterData:true});
    });
  }
  ticketUI(document);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => { linksIn(node); ticketUI(node); }));
  }).observe(document.body, {childList:true, subtree:true});
})();

